/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography } from "@material-ui/core";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NormalCard from "../../../cards/NormalCard";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "1rem 0rem 2rem 0rem",
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "1.875rem",
  },
  subHeading: {
    width: "100%",
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "1.75rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
      lineHeight: "1.6875rem",
    },
  },
  accordionContainer: {
    width: "100%",
  },
  heading: {
    width: "100%",
    color: "#000000",
    fontWeight: "400",
    fontSize: "2.125rem",
    lineHeight: "3.1875rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
}));

const SectionTwo = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <React.Fragment>
      <Typography variant="h1" component="h1" className={classes.heading}>
        How it works ?
      </Typography>
      <div className={classes.sectionContainer}>
        <Accordion
          square
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          className={classes.accordionContainer}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={props.ariacontrols}
            id={props.id}
          >
            <Typography
              variant="h5"
              component="h5"
              className={classes.subHeading}
            >
              Property Assistance
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordiondetail}>
            <div className={classes.flex}>
              <NormalCard
                icon="/images/icons/service/shortlisting.svg"
                title="Search & Shortlisting"
                text="Find the right property based on your style, budget and requirements"
              />
              <NormalCard
                icon="/images/icons/service/site_visit_assistance.svg"
                title="Site Visits"
                text="Guided property tour to make sure you catch all the details"
              />
              <NormalCard
                icon="/images/icons/service/nri_desk.svg"
                title="NRI"
                text="We assist in hassle free transaction and registration of your property"
              />
              <NormalCard
                icon="/images/icons/service/bulk_bookings.svg"
                title="Bulk Booking"
                text="Use the power of group to negotiate the best price for properties"
              />
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </React.Fragment>
  );
};

export default SectionTwo;
